/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { Link } from "react-router-dom";

const ResearchMenuItems = (props) => {
  const { isMobileMenu } = props;
  const [about, setAbout] = useState(false);
  const [research, setResearch] = useState(false);

  const openMobileMenu = (menu) => {
    if (menu === "about") {
      setAbout(!about);
      setResearch(false);
    } else if (menu === "research") {
      setAbout(false);
      setResearch(!research);
    }
  };

  const handleClick = (e) => {
    if (isMobileMenu) e.preventDefault();
  };

  return (
    <ul>
      <li>
        <Link to="/research">Home</Link>
      </li>
      <li className="has-dropdown">
        <Link to="#" className={about ? "expanded" : ""} onClick={handleClick}>
          About
          <button
            className={`${about ? "dropdown-toggle-btn dropdown-opened" : "dropdown-toggle-btn"} d-xl-none `}
            onClick={() => openMobileMenu("about")}
          >
            <i className="fal fa-angle-right"></i>
          </button>
        </Link>
        <ul className={about ? "it-submenu submenu d-block" : "it-submenu submenu"}>
          <li>
            <Link to="/research/director-message">Director Message</Link>
          </li>
          <li>
            <Link to="/research/vision-mission">Vision &amp; Mission</Link>
          </li>
          <li>
            <Link to="/research/team">Our Team</Link>
          </li>
        </ul>
      </li>
      <li className="has-dropdown">
        <Link to="#" className={research ? "expanded" : ""} onClick={handleClick}>
          Research
          <button
            className={`${research ? "dropdown-toggle-btn dropdown-opened" : "dropdown-toggle-btn"} d-xl-none `}
            onClick={() => openMobileMenu("research")}
          >
            <i className="fal fa-angle-right"></i>
          </button>
        </Link>
        <ul className={research ? "it-submenu submenu d-block" : "it-submenu submenu"}>
          <li>
            <Link to="/research/clinical-trials">Clinical Trials</Link>
          </li>
          <li>
            <Link to="/research/regulatory">Regulatory</Link>
          </li>
          <li>
            <Link to="/research/irb">IRB</Link>
          </li>
          <li>
            <Link to="/research/certifications">Certifications</Link>
          </li>
          <li>
            <Link to="/research/conferences">Conferences &amp; Meetings</Link>
          </li>
        </ul>
      </li>
      <li>
        <Link to="/research/team">Team</Link>
      </li>
      <li>
        <Link to="/research/contact">Contact</Link>
      </li>
      <li className="research-cta-li">
        <Link
          to="/"
          className="ma-btn-primary"
          style={{
            borderRadius: 8,
            fontSize: ".875rem",
            padding: "10px 20px",
            display: "inline-block",
            textDecoration: "none",
          }}
        >
          <i className="fa-regular fa-arrow-left" style={{ marginRight: 7 }}></i>
          Main Site
        </Link>
      </li>
    </ul>
  );
};

export default ResearchMenuItems;
